class Bundle {
  constructor() {
    // Initialize all DOM selectors
    this.bundleJsonContainer = document.querySelector('#bundle-json')
    this.bundleItemsMobileWrapper = document.querySelector('[data-bundle-items-mobile-container]')
    this.bundleWrap = document.querySelector('[data-bundle-wrap]')

    // Initialize additional selectors if primary elements exist
    if (this.bundleItemsMobileWrapper) {
      this.bundleContainerMobile = this.bundleItemsMobileWrapper.querySelector('[data-bundle-items-mobile]')
    }

    if (this.bundleWrap) {
      this.regularATC = this.bundleWrap.querySelector('[data-content-available]')
      this.soldoutATC = this.bundleWrap.querySelector('[data-content-soldout]')
      this.qtySelector = this.bundleWrap.querySelector('[data-variant-qty-wrap]')
      this.productInfo = this.bundleWrap.querySelector('[data-product-info]')
      this.inStockText = this.bundleWrap.querySelector('[data-in-stock-text]')
    }

    // Initialize bundle data if JSON container exists
    if (this.bundleJsonContainer) {
      this.bundleJSON = JSON.parse(this.bundleJsonContainer.innerHTML)
      this.bundleProducts = this.bundleJSON.products
      
      this.init()
      this.events()

      document.addEventListener('linked-product:updated', () => this.bundleOOS())
    }
  }

  //--------------------------------------
  // register events handlers
  //--------------------------------------
  events() {
    window.addEventListener('load', () => {
      // Add any load event handling here
    })
  } //events()

  //--------------------------------------
  // Render bundle items
  //--------------------------------------
  renderBundleItems() {
    if (!this.bundleProducts || !this.bundleContainerMobile) return

    this.bundleProducts.forEach(product => {
      const { 
        product_title: productTitle,
        variant_title: variantTitle,
        product_images,
        variant_featured_image: variantImage,
        url 
      } = product

      const item = document.createElement('div')
      item.classList.add('bundle-item')

      const imageSource = variantTitle.toLowerCase() !== 'default title' 
        ? variantImage 
        : product_images[0].src

      item.innerHTML = `
        <div class='bundle-item-inner'>
          <a href='${url}'>
            <div class='bundle-item-img-container'>
              <img class='bundle-item-img' src='${imageSource}' alt='${productTitle}'>
            </div>
            <h6 class='bundle-item-title'>${productTitle}</h6>
          </a>
        </div>
      `

      this.bundleContainerMobile.appendChild(item)
    })
  }

  //--------------------------------------
  // Check if bundle should be OOS
  //--------------------------------------
  bundleOOS() {
    if (!this.bundleWrap) return

    // Refresh bundle JSON data
    const bundleJsonContainer = document.querySelector('#bundle-json')
    if (!bundleJsonContainer) return

    this.bundleJSON = JSON.parse(bundleJsonContainer.innerHTML)
    const bundleOOS = this.bundleJSON.bundle_OOS

    if (bundleOOS) {
      this.regularATC?.classList.add('hide')
      this.soldoutATC?.classList.remove('hide')
      this.qtySelector?.classList.add('hide')
      this.inStockText?.classList.add('hide')

      const existingBadge = this.bundleWrap.querySelector('[data-badge1]')
      
      if (!existingBadge && this.productInfo) {
        const comingSoonBadge = document.createElement('div')
        comingSoonBadge.innerHTML = 'Coming Back Soon'
        comingSoonBadge.classList.add('badge1')
        comingSoonBadge.setAttribute('data-badge1', true)
        this.productInfo.prepend(comingSoonBadge)
      }
    } else {
      this.regularATC?.classList.remove('hide')
      this.soldoutATC?.classList.add('hide')
      this.qtySelector?.classList.remove('hide')

      const existingBadge = this.bundleWrap.querySelector('[data-badge1]')
      existingBadge?.remove()
    }
  }

  //--------------------------------------
  // load()
  //--------------------------------------
  load = () => {
    this.renderBundleItems()
    this.bundleOOS()
  }

  init() {
    document.addEventListener('shopify:section:load', this.load)

    try {
      this.load()
    } catch (err) {
      console.error('Bundle initialization error:', err)
    }
  }
}

new Bundle()